var keysFunc = Object.keys || Ember.keys;
var create = Object.create || Ember.create;

export { create, keysFunc };